<mat-dialog-content>
  <h2>Cancel subscription</h2>
  <p>
    By pressing "End subscription" below, you will no longer be billed for your
    subscription. You will still be able to access all of the features of your
    subscription until the end of this billing period.
  </p>
  <p>
    Note that if you add another user to your organization before the end of the
    current billing period, you will be charged for that user until the end of
    the current billing period.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="closeDialog()">Close</button>
  <button
    mat-raised-button
    color="warn"
    (click)="cancelSubscription()"
    cdkFocusInitial
  >
    End subscription
  </button>
</mat-dialog-actions>
